import {BaseDTO} from '../../common/models/BaseDTO';
import {DiagnosisDTO} from './DiagnosisDTO';
import {DiagnosisGroupDTO} from './diagnosis/DiagnosisGroupDTO';

export class InsuredPersonExclusionDTO extends BaseDTO {
  insuredPersonId: number;
  diagnosis: DiagnosisDTO;
  diagnosisGroup: DiagnosisGroupDTO;
  startDate: Date;
  endDate: Date;
}
